export const STATUS = {
  INVALID: 'I',
  VALID: 'V',
  REJECTED: 'R',
  IRREDEEMABLE: 'IR',
  REDEEMED: 'RE',
  EXPIRED: 'EP',
}
